import React from "react";
import Header from "./Component/Header";
import Home from "./Component/Home";
import Footer from "./Component/Footer";

const App = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default App;
